// @flow
import React from 'react';
import styled from 'styled-components';
import Spinner from './Spinner';

const Overlay = styled.div`
  background-color: rgba(255, 255, 255, 0.85);
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

type SpinnerOverlayProps = {
  active?: boolean,
};

const SpinnerOverlay = ({ active }: SpinnerOverlayProps) => {
  if (!active) {
    return null;
  }

  return (
    <Overlay>
      <Spinner />
    </Overlay>
  );
};

SpinnerOverlay.defaultProps = { active: true };

export default SpinnerOverlay;
